import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ActivityBox from './ActivityBox';
import UploadFileContainer from './UploadFileContainer';
import BookTitleBox from './BookTitleBox';
import { I18n } from 'react-redux-i18n-lite';
import { getAsset } from '../../../services/assets/assetsService';
import { connect } from 'react-redux';
import UserResponse from './UserResponse';
import { ROLE } from '../../../const';
import CircularProgress from '@material-ui/core/CircularProgress';
import { bindActionCreators } from 'redux';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import TruncateMarkup from 'react-truncate-markup';
import dayjs from 'dayjs';
import { getTaskFiles } from '../../../services/domain/taskService';

const MAX_LINES = 3;

class ContentTaskContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultFile: [],
      fileResponsesActiveLoader: true,
      taskFilesActiveLoader: true,
      shouldTruncate: true
    };

    this.toggleLines = this.toggleLines.bind(this);
    this.renderTaskWording = this.renderTaskWording.bind(this);
  }

  componentDidMount() {
    const { task, customer } = this.props;

    this.getResponseFile();

    getTaskFiles(task, customer.id)
      .then(fetchedFiles => {
        this.setState({
          files: fetchedFiles,
          taskFilesActiveLoader: false
        });
      })
      .catch(() => {
        this.setState({
          taskFilesActiveLoader: false
        });
      });
  }

  static propTypes = {
    task: PropTypes.any,
    uploadingFile: PropTypes.bool,
    deleteResponseFile: PropTypes.func,
    user: PropTypes.any,
    isTeacher: PropTypes.bool,
    onChangeFile: PropTypes.func,
    customer: PropTypes.object,
    canChangeFile: PropTypes.bool,
    commentMessageText: PropTypes.any,
    role: PropTypes.any,
    onInputMessage: PropTypes.any,
    canChange: PropTypes.any,
    uploadStatus: PropTypes.object,
    userRole: PropTypes.string,
    book: PropTypes.any
  };

  static defaultProps = {
    uploadingFile: false
  };

  renderTaskWording() {
    const { shouldTruncate } = this.state;
    const { task } = this.props;
    const readMoreEllipsis = (
      <span>
        ...
        <span className="read-more-button" onClick={this.toggleLines}>{` [${I18n.t(
          'panels.assignment.showMore'
        )}]`}</span>
      </span>
    );
    return (
      <div className="task-wording" translate="no">
        <div className={!shouldTruncate ? 'expanded' : ''}>
          {shouldTruncate ? (
            <TruncateMarkup lines={MAX_LINES} ellipsis={readMoreEllipsis}>
              <span>{task.wording}</span>
            </TruncateMarkup>
          ) : (
            <span>
              {task.wording}
              <span className="read-more-button" onClick={this.toggleLines}>
                {` [${I18n.t('panels.assignment.showLess')}]`}
              </span>
            </span>
          )}
        </div>
      </div>
    );
  }

  //--------------------------------------------------------------------------------------------------------------------
  toggleLines(event) {
    event.preventDefault();
    this.setState({ shouldTruncate: !this.state.shouldTruncate });
  }

  renderTitle() {
    const { task } = this.props;
    const firstUser = task.studentAttempts && Object.values(task.studentAttempts)[0];
    return (
      <span className="section-title-label">
        {I18n.t('panels.assignment.contentTask')}
        {firstUser && firstUser.taskGroup && ` \u00B7 ${I18n.t('rightPanel.groups.group')} ${firstUser.taskGroup}`}
      </span>
    );
  }

  getResponseFile() {
    const { task, user, customer, userRole } = this.props;
    if (task.studentAttempts[user._id].responses.length > 0) {
      const lastResponse =
        task.studentAttempts[user._id].responses[task.studentAttempts[user._id].responses.length - 1];
      if (lastResponse && lastResponse.data && lastResponse.data.files && lastResponse.data.files) {
        const files = lastResponse.data && lastResponse.data.files;
        const getAssetPromises = files.map(res => getAsset(res.split('/').pop(), customer.id));

        Promise.allSettled(getAssetPromises).then(res => {
          const okResponses = res.filter(r => r.status !== 'rejected');

          if (
            !okResponses.length &&
            userRole === 'STUDENT' &&
            new Date(task.dueDate).getTime() > new Date().getTime()
          ) {
            // En caso de que todos los assets en las respuestas no existan,
            // habilitamos el botón de subir
            // https://jira.netexlearning.com/browse/SMARTCLASS-4943
            this.setState({ showBrowseButton: true });
          }

          this.setState({
            defaultFile: okResponses.map(r => r.value.data),
            fileResponsesActiveLoader: false
          });
        });
      } else {
        this.setState({ fileResponsesActiveLoader: false });
      }
    } else {
      this.setState({ fileResponsesActiveLoader: false });
    }
  }

  //--------------------------------------------------------------------------------------------------------------------
  render() {
    const {
      commentMessageText,
      role,
      task,
      isTeacher,
      onChangeFile,
      onInputMessage,
      uploadingFile,
      user,
      canChange,
      deleteResponseFile,
      uploadStatus,
      book
    } = this.props;

    const thereIsCommentResponse = task => {
      return (
        task.studentAttempts[user._id] &&
        task.studentAttempts[user._id].responses.filter(res => res.data && res.data.commentMessageText).length
      );
    };

    const expiredAllowAndNotResponse = task => {
      return !(!thereIsCommentResponse(task) && task.allowExpiredResponse);
    };

    const isTaskExpired = dayjs(task.dueDate).isBefore(dayjs());

    const isCommentResponseDisabled = task => {
      if (isTaskExpired) {
        return expiredAllowAndNotResponse(task);
      }
      return thereIsCommentResponse(task);
    };

    const canStudentRepeatTask = task.studentAttempts[user._id]
      ? task.studentAttempts[user._id].canStudentRepeat
      : false;

    return (
      <div>
        <div className="content-task-container">
          {/* {this.renderSubmitModal()}*/}
          {this.renderTitle()}

          {this.renderTaskWording()}
          {task.allowFileResponse && !uploadStatus.isUploading && (
            <UploadFileContainer
              deleteResponseFile={(e, index) => deleteResponseFile(e, index)}
              disableClick={
                uploadingFile ||
                !task.allowFileResponse ||
                isTeacher ||
                (!task.allowExpiredResponse && new Date(task.dueDate) < new Date())
              }
              defaultFile={Boolean(role === ROLE.STUDENT && canStudentRepeatTask) ? null : this.state.defaultFile}
              onChangeFile={onChangeFile}
              showLoader={this.state.fileResponsesActiveLoader}
              canChange={canChange}
              isInstructor={isTeacher}
              isResponseContainer={true}
              studentCanUpload={
                this.state.showBrowseButton ||
                (task.allowFileResponse &&
                  !(task.studentAttempts[user._id].responses && task.studentAttempts[user._id].responses.length))
              }
            />
          )}
          {uploadStatus.isUploading && (
            <div
              style={{
                position: 'relative',
                textAlign: 'center',
                padding: '2em'
              }}
              key={'loader'}
            >
              <CircularProgress style={{ display: 'inlineBlock' }}></CircularProgress>
            </div>
          )}
          {task.allowUserCommentResponse ? (
            <UserResponse
              disabled={Boolean(role === ROLE.INSTRUCTOR || isCommentResponseDisabled(task)) && !canStudentRepeatTask}
              placeHolder={
                role === ROLE.INSTRUCTOR
                  ? `${I18n.t('panels.assignment.withoutComment')}`
                  : `${I18n.t('panels.assignment.addComment')} ${I18n.t('common.optional')}`
              }
              onInput={onInputMessage}
              value={commentMessageText}
            />
          ) : null}

          {Boolean(task.files && task.files.length) && (
            <>
              <span className="section-title-label">{I18n.t('common.files')}</span>
              <UploadFileContainer
                disableClick={true}
                defaultFile={this.state.files}
                showLoader={this.state.taskFilesActiveLoader}
                canChange={false}
                isTaskFile={true}
                isInstructor={isTeacher}
              />
            </>
          )}

          {book && <BookTitleBox book={book} classroomId={task.parentSection} task={task} />}

          <ActivityBox
            classroomId={task.parentSection}
            isTeacher={isTeacher}
            activities={task.activityStructure}
            withResults={task.withResults}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: state.account.user.role,
    customer: state.school.school.customer,
    role: state.classrooms.selectedClassroom.classroom.role,
    uploadStatus: state.assignmentsDrawerActions.uploadFileTaskStatus,
    i18n: state.i18n
  };
}
function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentTaskContainer);
